/**
 * useEffectiveUserId hook
 *
 * Returns the effective user identity considering shadow mode.
 * In shadow mode, the backend returns data for the target user,
 * so client-side comparisons (e.g., filtering "my" expenses)
 * must use the target user's ID instead of the admin's real ID.
 */
import { useShadowMode, useShadowTarget } from '@splitfiesta/core';

import { useAuthStore } from '@/stores/authStore';

export function useEffectiveUserId(): string | undefined {
  const user = useAuthStore(state => state.user);
  const isShadowActive = useShadowMode();
  const shadowTarget = useShadowTarget();

  if (isShadowActive && shadowTarget?.id) {
    return shadowTarget.id;
  }

  return user?.id;
}
